module.exports = __webpack_public_path__ + "img/news-03.a52f230f.jpg";